import * as React from 'react'
import { ReactElement } from 'react'
const SvgCashOut = (props: any): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#171717"
      fillRule="evenodd"
      d="M11.996 4.55A2 2 0 0 0 10 2.666H3.333l-.117.003a2 2 0 0 0-1.883 1.997v4l.004.117a2 2 0 0 0 1.996 1.883H4v.666a2 2 0 0 0 2 2h6.667a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H12v-.666l-.004-.118Zm-.662 2.117H6a.667.667 0 0 0-.667.666v4c0 .369.299.667.667.667h6.667a.667.667 0 0 0 .666-.667v-4a.667.667 0 0 0-.666-.666h-1.333ZM4 9.333v-2a2 2 0 0 1 2-2h4.667v-.666a.667.667 0 0 0-.59-.662L10 4H3.333a.667.667 0 0 0-.662.589l-.004.078v4c0 .342.257.623.589.662l.077.004H4Zm3.333 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2.667 0a.667.667 0 1 0-1.333 0 .667.667 0 0 0 1.333 0Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgCashOut
